// extracted by mini-css-extract-plugin
export default {"title":"Title_title__IlEm8","title--sub":"Title_title--sub__Ua4JJ"};